import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the AppFoodTrackingInfoPopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-food-tracking-info-popup',
  templateUrl: 'app-food-tracking-info-popup.html',
})
export class AppFoodTrackingInfoPopupPage {

  public selectedGroup: string = '';
  public selectedSection: number = 1;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppFoodTrackingInfoPopupPage');
  }

  openGroup(group, section = 1) {
    this.selectedGroup = group;
    this.selectedSection = section;
  }

  goBack() {
    if(this.selectedGroup) {
      this.selectedGroup = '';
    } else {
      this.navCtrl.pop();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-food-tracking-info-popup/app-food-tracking-info-popup.ts